var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inputValue)?_c('div',{staticClass:"style-box"},[_c('RxNameValueInput',{attrs:{"value":_vm.inputValue.meta.styles},on:{"changed":_vm.stylesChanged}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f842aed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/options/StyleBox.vue
// module id = 113
// module chunks = 0 1